<div class="perm-admin-container">
    <div fxLayout="column">
        <div *ngIf="showMenu|async" class="perm-admin-menu">
            <nav #navBar mat-tab-nav-bar mat-align-tabs="center" class="menu-content" color="primary">
                <!-- Resources -->
                <a mat-tab-link class="menu-item"
                   [routerLink]="['/c', 'permissions', 'resources']" [queryParams]="{}" queryParamsHandling="merge"
                   routerLinkActive #rlaResources="routerLinkActive" [active]="rlaResources.isActive">
                    <app-icon name="fal-network-wired"></app-icon>&nbsp;&nbsp;{{'Resources'|i18n}}
                </a>
                <!-- Connectors -->
                <a mat-tab-link class="menu-item"
                   [routerLink]="['/c', 'permissions', 'connectors']" [queryParams]="{}" queryParamsHandling="merge"
                   routerLinkActive #rlaConnectors="routerLinkActive" [active]="rlaConnectors.isActive">
                    <app-icon name="fal-plug"></app-icon>&nbsp;&nbsp;{{'Connectors'|i18n}}
                </a>
                <!-- Users -->
                <a mat-tab-link class="menu-item"
                   [routerLink]="['/c', 'permissions', 'users']" [queryParams]="{}" queryParamsHandling="merge"
                   routerLinkActive #rlaUsers="routerLinkActive" [active]="rlaUsers.isActive">
                    <app-icon name="fal-users"></app-icon>&nbsp;&nbsp;{{'Users'|i18n}}
                </a>
            </nav>
        </div>
        <div *ngIf="showUsersPermAssignments|async" fxLayout="row" fxLayoutAlign="end" class="mt-24">
            <button mat-stroked-button color="primary" class="view-user-assignments-button"
               [routerLink]="['/c', 'permissions', 'users-assignments']"
               [queryParams]="{returnUrl: currentUrl}" queryParamsHandling="merge"
               routerLinkActive #rlaUsersPermAssignments="routerLinkActive">
                <app-icon name="fal-users"></app-icon>&nbsp;&nbsp;{{'View users assignments'|i18n}}
            </button>
        </div>
        <div class="perm-admin-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
